var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tvos-thousands',{staticClass:"tvos-jpy",attrs:{"value":_vm.value,"prefix":"¥"}})}
var staticRenderFns = []

export { render, staticRenderFns }